import { STORY_POINTS_ALIAS_FIELD_ID } from '@atlassian/jira-business-constants';
import {
	type BusinessIssueField,
	useFindField,
	type GenericIssueField,
} from '@atlassian/jira-business-entity-project';
import {
	CATEGORY_TYPE,
	NUMBER_CF_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
	SPRINT_TYPE,
} from '@atlassian/jira-platform-field-config';
import { useIssueFields } from '../get-issue-fields';
import { useGroupBy } from '../group-by';

export const categoryFieldPredicate = (field: GenericIssueField) => field.type === CATEGORY_TYPE;

export const storyPointsFieldPredicate = (field: GenericIssueField) =>
	field.type === NUMBER_CF_TYPE && field.aliasFieldId === STORY_POINTS_ALIAS_FIELD_ID;

export const storyPointEstimateFieldPredicate = (field: GenericIssueField) =>
	field.type === STORY_POINT_ESTIMATE_CF_TYPE;

export const sprintFieldPredicate = (field: GenericIssueField) => field.type === SPRINT_TYPE;

export const useGetGroupByField = (): BusinessIssueField | null | undefined => {
	const [groupByFieldId] = useGroupBy();
	const { getAvailableFields } = useIssueFields();
	const availableFields = getAvailableFields();

	const { data: categoryField } = useFindField(categoryFieldPredicate);
	const { data: storyPointsField } = useFindField(storyPointsFieldPredicate);
	const { data: storyPointEstimateField } = useFindField(storyPointEstimateFieldPredicate);
	const { data: sprintField } = useFindField(sprintFieldPredicate);

	switch (groupByFieldId) {
		case categoryField?.id:
			return categoryField;
		case storyPointsField?.id:
			return storyPointsField;
		case storyPointEstimateField?.id:
			return storyPointEstimateField;
		case sprintField?.id:
			return sprintField;
		default:
			return availableFields.find((availableField) => availableField.type === groupByFieldId);
	}
};
